import { useMemo } from 'react';

import { useAccountPersistentStore } from '../../../modules/store/accountPersistentStore';
import { hasBoundlessCobrandRelationship } from '../utils/hasBoundlessCobrandRelationship';

export interface UseBoundlessCobrandRelationshipArgs {
  skip?: boolean;
}

/**
 * Reads cobrand partner codes from phoenixAccountGetMemberStatusDetails data already
 * loaded on Profile (MemberSnapshotRibbon → accountPersistentStore).
 */
export function useBoundlessCobrandRelationship({ skip = false }: UseBoundlessCobrandRelationshipArgs = {}) {
  const memberData = useAccountPersistentStore(state => state.memberData);

  const hasBoundlessRelationship = useMemo(() => {
    if (skip) {
      return false;
    }

    const coBrands = memberData?.customer?.loyaltyInformation?.programPartners?.coBrands;

    return hasBoundlessCobrandRelationship(coBrands);
  }, [memberData, skip]);

  return {
    hasBoundlessRelationship,
    isLoading: !skip && !memberData,
  };
}
